import { render, staticRenderFns } from "./OtsPagination.vue?vue&type=template&id=6db6586e&scoped=true&"
import script from "./OtsPagination.vue?vue&type=script&lang=js&"
export * from "./OtsPagination.vue?vue&type=script&lang=js&"
import style0 from "./OtsPagination.vue?vue&type=style&index=0&id=6db6586e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db6586e",
  null
  
)

export default component.exports